import React from 'react';
import { IonContent, IonPage } from '@ionic/react';

import OverlayLogin from '../components/OverlayLogin';

interface WelcomeProps {
  type: string
}

const Welcome: React.FC<WelcomeProps> = ({ type }) => {
  let config;
  switch (type) {
    case 'flow':
      config = {
        title: 'Partagez votre expérience',
        text:'Partagez vos repas, evaluez ceux des autres, avancez ensemble !',
        img: '/assets/img/flow.jpg'
      }
      break;
    
    case 'progress':
      config = {
        title: 'Suivez votre progression',
        text:'Suivez votre alimentation, analysez vos repas grâce aux retours des autres',
        img: '/assets/img/diet.jpg'
      }
      break;
  
    default:
      config = {
        title: 'Carnet d\'alimentation',
        text:'Notez ce que vous mangez quand vous mangez.',
        img: '/assets/img/diary.jpg'
      }
      break;
  }
  return (
    <IonPage>
      <IonContent fullscreen>
        <OverlayLogin
          title={config.title}
          text={config.text}
          img={config.img}
        />
      </IonContent>
    </IonPage>
  );
};

export default Welcome;
